

setTimeout(() => {
  document.querySelector(".body").classList.add("loaded");
}, 2000);


let scrollPosition = window.scrollY;
const header = document.querySelector(".header");
const scrollChange = 10;
const addClassOnScroll = () => header.classList.add("header--scroll");
const removeClassOnScroll = () => header.classList.remove("header--scroll");
if(scrollPosition > scrollChange) {
  addClassOnScroll();
} else {
  removeClassOnScroll();
}
window.addEventListener("scroll", () => {
  scrollPosition = window.scrollY;
  if (scrollPosition >= scrollChange) {
    addClassOnScroll();
  } else if (scrollPosition <= scrollChange) {
    removeClassOnScroll();
  }
});

const NAV_LINKS = document.querySelectorAll('.nav-link--down');
const NAV_DROPDOWN = document.querySelectorAll('.menu-dropdown');
if(NAV_LINKS.length > 0) {
  for(let i = 0; i < NAV_LINKS.length; i++) {
    NAV_LINKS[i].addEventListener('click', e => {
      NAV_DROPDOWN[i].classList.toggle('open');
    })
  }
}

const HEADER_BUTTON = document.querySelector(".header-burger");
const HEADER_MENU = document.querySelector(".header-right");
HEADER_BUTTON.addEventListener("click", () => {
  HEADER_BUTTON.classList.toggle("open");
  HEADER_MENU.classList.toggle("show");
  document.querySelector('.body').classList.toggle('lock');
  NAV_DROPDOWN.forEach(drop => {
    if(drop.classList.contains('open')) drop.classList.remove('open');
  })
});









const sel = document.querySelector(".select");
if (sel) {
  const CLASS_NAME_SELECT = "select";
  const CLASS_NAME_ACTIVE = "select_show";
  const CLASS_NAME_SELECTED = "select__option_selected";
  const SELECTOR_ACTIVE = ".select_show";
  const SELECTOR_DATA = "[data-select]";
  const SELECTOR_DATA_TOGGLE = '[data-select="toggle"]';
  const SELECTOR_OPTION_SELECTED = ".select__option_selected";
  const customClass = "select__toggle--light";

  class CustomSelect {
    constructor(target, params) {
      this._elRoot =
        typeof target === "string" ? document.querySelector(target) : target;
      this._params = params || {};
      if (this._params["options"]) {
        this._elRoot.classList.add(CLASS_NAME_SELECT);
        this._elRoot.innerHTML = CustomSelect.template(this._params);
      }
      this._elToggle = this._elRoot.querySelector(SELECTOR_DATA_TOGGLE);
      this._elRoot.addEventListener("click", this._onClick.bind(this));
    }
    _onClick(e) {
      const target = e.target;
      const type = target.closest(SELECTOR_DATA).dataset.select;
      switch (type) {
        case "toggle":
          this.toggle();
          break;
        case "option":
          this._changeValue(target);
          break;
      }
    }

    _update(option) {
      const selected = this._elRoot.querySelector(SELECTOR_OPTION_SELECTED);
      if (selected) {
        selected.classList.remove(CLASS_NAME_SELECTED);
      }
      option.classList.add(CLASS_NAME_SELECTED);
      this._elToggle.textContent = option.textContent;
      this._elToggle.value = option.dataset["value"];
      this._elToggle.dataset.index = option.dataset["index"];
      this._elRoot.dispatchEvent(new CustomEvent("select.change"));
      this._params.onSelected ? this._params.onSelected(this, option) : null;
      return option.dataset["value"];
    }

    _reset() {
      const selected = this._elRoot.querySelector(SELECTOR_OPTION_SELECTED);
      if (selected) {
        selected.classList.remove(CLASS_NAME_SELECTED);
      }
      this._elToggle.textContent = "Выберите из списка";
      this._elToggle.value = "";
      this._elToggle.dataset.index = -1;
      this._elRoot.dispatchEvent(new CustomEvent("select.change"));
      this._params.onSelected ? this._params.onSelected(this, null) : null;
      return "";
    }

    _changeValue(option) {
      if (option.classList.contains(CLASS_NAME_SELECTED)) {
        return;
      }
      this._update(option);
      this.hide();
    }

    show() {
      document.querySelectorAll(SELECTOR_ACTIVE).forEach((select) => {
        select.classList.remove(CLASS_NAME_ACTIVE);
      });
      this._elRoot.classList.add(CLASS_NAME_ACTIVE);
    }

    hide() {
      this._elRoot.classList.remove(CLASS_NAME_ACTIVE);
    }

    toggle() {
      if (this._elRoot.classList.contains(CLASS_NAME_ACTIVE)) {
        this.hide();
      } else {
        this.show();
      }
    }

    dispose() {
      this._elRoot.removeEventListener("click", this._onClick);
    }

    get value() {
      return this._elToggle.value;
    }

    set value(value) {
      let isExists = false;
      this._elRoot.querySelectorAll(".select__option").forEach((option) => {
        if (option.dataset["value"] === value) {
          isExists = true;
          return this._update(option);
        }
      });
      if (!isExists) {
        return this._reset();
      }
    }

    get selectedIndex() {
      return this._elToggle.dataset["index"];
    }

    set selectedIndex(index) {
      const option = this._elRoot.querySelector(
        `.select__option[data-index="${index}"]`
      );
      if (option) {
        return this._update(option);
      }
      return this._reset();
    }
  }

  CustomSelect.template = (params) => {
    const name = params["name"];
    const options = params["options"];
    const targetValue = params["targetValue"];
    const addClass = params["addClass"] ? params["addClass"] : "";
    let items = [];
    let selectedIndex = -1;
    let selectedValue = "";
    let selectedContent = "Выберите из списка";
    options.forEach((option, index) => {
      let selectedClass = "";
      if (option[0] === targetValue) {
        selectedClass = " select__option_selected";
        selectedIndex = index;
        selectedValue = option[0];
        selectedContent = option[1];
      }
      items.push(
        `<li class="select__option${selectedClass}" data-select="option" data-value="${option[0]}" data-index="${index}">${option[1]}</li>`
      );
    });
    return `<button type="button" class="select__toggle ${
      document.querySelector(".hero-select--light") ? customClass : false
    }" name="${name}" value="${selectedValue}" data-select="toggle" data-index="${selectedIndex}">${selectedContent}</button>
  <div class="select__dropdown">
    <ul class="select__options ${addClass}">${items.join("")}</ul>
  </div>`;
  };

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".select")) {
      document.querySelectorAll(SELECTOR_ACTIVE).forEach((select) => {
        select.classList.remove(CLASS_NAME_ACTIVE);
      });
    }
  });
  const sidebar = document.querySelector(".sidebar");
  if (sidebar) {
    const select8 = new CustomSelect("#select-1", {
      name: "time",
      targetValue: "Категории",
      options: [
        ["Категории", "Категории"],
        ["Сёрфинг направления", "Сёрфинг направления"],
        ["Искусственный сёрфинг", "Искусственный сёрфинг"],
        ["Скейтинг", "Скейтинг"],
        ["Жизнь клуба", "Жизнь клуба"],
        ["Спецкор “Surfway”", "Спецкор “Surfway”"],
        ["Теория сёрфинга", "Теория сёрфинга"],
        ["СМИ о нас", "СМИ о нас"],
      ],
    });
  }

  const photosSelect = document.querySelector(".photos-select ");
  if (photosSelect) {
    const select9 = new CustomSelect("#select-2", {
      addClass: "photos-select-grid",
      name: "Страна",
      targetValue: "Марокко",
      options: [
        ["Бали", "Бали"],
        ["Владивосток", "Владивосток"],
        ["Ирландия", "Ирландия"],
        ["Индонезия, о.Сумбава", "Индонезия, о.Сумбава"],
        ["Калининград", "Калининград"],
        ["Камчатка", "Камчатка"],
        ["Канарские о-ва", "Канарские о-ва"],
        ["Коста-Рика", "Коста-Рика"],
        ["Крым", "Крым"],
        ["Малибу", "Малибу"],
        ["Мексика", "Мексика"],
        ["Перу", "Перу"],
        ["Португалия", "Португалия"],
        ["Санкт-Петербург", "Санкт-Петербург"],
        ["Сочи", "Сочи"],
        ["Филиппины", "Филиппины"],
        ["Шри-ланка", "Шри-ланка"],
        ["ЮАР", "ЮАР"],
        ["Япония", "Япония"],
      ],
    });
    const select10 = new CustomSelect("#select-3", {
      addClass: "photos-select-years",
      name: "Год",
      targetValue: "2021",
      options: [
        ["2021", "2021"],
        ["2020", "2020"],
        ["2019", "2019"],
        ["2018", "2018"],
        ["2017", "2017"],
        ["2016", "2016"],
        ["2015", "2015"],
        ["2014", "2014"],
      ],
    });
  }
  const NEAR_SECTION = document.querySelector(".near-select");
  if (NEAR_SECTION) {
    const select11 = new CustomSelect("#select-4", {
      addClass: "near-tabs--mobile",
      name: "сезон",
      targetValue: "Осень 2021",
      options: [
        ["Осень 2021", "Осень 2021"],
        ["Зима 2021-2022", "Зима 2021-2022"],
        ["Весна 2022", "Весна 2022"],
      ],
    });
    const NEAR_TABS = document.querySelector(".near-tabs--mobile");
    const NEAR_CONTENT = document.querySelectorAll('.near-content');
    NEAR_TABS.addEventListener('click', e => {
      const target = e.target.closest('.select__option');
      const index = Number(target.getAttribute('data-index')) + 1;
      if(!target) return;
      NEAR_CONTENT.forEach(content => content.classList.remove('near-content--active'));
      document.querySelector(`.near-content--${index}`).classList.add('near-content--active')
    })
  }
}
